<div class="content-container">
    <div *ngIf="state == 1" class="content-container">
        <app-customer-info [article]="article" (orderEmitter)="fwdOrder($event)"></app-customer-info>
    </div>
    <div *ngIf="state == 2" class="content-container">
        <app-checkout [order]="order"></app-checkout>
    </div>
    <div class="button-container">
        <button i18n *ngIf="state > 1" (click)='selectState(state-1)' class="back-button">Back</button>
        <button i18n  mat-dialog-close>Cancel order</button>
    </div>
</div>